export default __webpack_public_path__ + "static/media/grahpIcon.d75b874d.svg";